import { Middleware } from 'redux';
import AnyAction from 'store/anyActions';
import RootState from 'store/state';
import setShortcuts  from "./os.shortcuts";
import setGeneralShortcuts  from "./general.shortcuts";
import { getOS } from 'utils';

const shortcutMiddleware: Middleware<{}, RootState> = store => {

  setGeneralShortcuts(store); // Set single key navigation shortcuts

  // Set shortcuts based on running OS
  if(getOS() === 'Mac') setShortcuts(store, 'Mac'); 
  if(getOS() === 'Win') setShortcuts(store, 'Windows'); 

  return next => async (action: AnyAction) => {
    switch(action.type){
      default:
        return next(action);
    }
  }
}

export default shortcutMiddleware;
